import React from "react";

// App
import { hasCoordinates } from "../hotelData";
import { ApiPath, Notice, Section } from "./apiField";

// Same /map.html iframe the at-a-glance block drops into a slide in view mode,
// so a pin here matches what a presentation shows.
export default function MapSection({ location, identity, apiKey }) {
  const plottable = hasCoordinates(location);

  return (
    <Section
      id="map"
      title="Map"
      path={`${location.latPath} / ${location.lngPath}`}
    >
      {!plottable ? (
        <Notice tone="warn">No coordinates.</Notice>
      ) : !apiKey ? (
        <Notice tone="warn">
          No <code>googleApiKey</code> in the theme.
        </Notice>
      ) : (
        <div className="rhp-map">
          <iframe
            title={`Map for ${identity.name || identity.code}`}
            src={`/map.html?entity=true&lat=${location.lat}&lng=${
              location.lng
            }&zoom=15&key=${apiKey}&label=${encodeURIComponent(
              identity.name || "",
            )}`}
            frameBorder="0"
          />
        </div>
      )}

      <div className="rhp-map__meta">
        <span>
          lat <code>{String(location.lat ?? "—")}</code>
        </span>
        <span>
          lng <code>{String(location.lng ?? "—")}</code>
        </span>
        <ApiPath path={`${location.latPath} / ${location.lngPath}`} />
      </div>
    </Section>
  );
}
